// Thin API for the proxy-customer dashboard tool.
const http = () => window.axios;

const base = accountId => `/api/v1/accounts/${accountId}/proxy_customers`;

export const listProxyCustomers = async accountId => {
  const { data } = await http().get(base(accountId));
  return data;
};

export const createProxyCustomer = async (accountId, payload = {}) => {
  const { data } = await http().post(base(accountId), payload);
  return data;
};

export const fetchProxyCustomerSession = async (accountId, contactId) => {
  const { data } = await http().get(`${base(accountId)}/${contactId}/session`);
  return data;
};

export const renameProxyCustomer = async (accountId, contactId, name) => {
  const { data } = await http().patch(`${base(accountId)}/${contactId}`, { name });
  return data;
};
